module.exports = __webpack_public_path__ + "img/sintesis.3f14cda3.svg";